import { PropsWithChildren } from "react";
import { GroupsContext, GroupsContextType } from "./GroupsContext";

export const GroupsContextProvider = ({ children, ...props }: PropsWithChildren<GroupsContextType>) => (
  <GroupsContext.Provider value={props}>{children}</GroupsContext.Provider>
);
